import type { SVGProps } from "react";

const PATHS = {
  camera: "M3 7h12v12H3V7ZM15 11l6-3v10l-6-3M6 4h6",
  wrench: "M14.5 5.5a5 5 0 0 0-6 6L3 17a2.1 2.1 0 0 0 3 3l5.5-5.5a5 5 0 0 0 6-6L14 12l-3-3 3.5-3.5Z",
  child: "M12 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM7 11l5 2 5-2M12 10v7M8 21l4-4 4 4",
  home: "M3 11.5 12 4l9 7.5M5.5 10v9.5h13V10M10 19.5v-5h4v5",
  users: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM2.5 20c.6-3.6 3.2-5.5 6.5-5.5s5.9 1.9 6.5 5.5M16 4.3a3.5 3.5 0 0 1 0 6.4M18 14.8c2 .6 3.2 2.2 3.5 5.2",
  house: "M4 20V9.5L12 4l8 5.5V20M9 20v-6h6v6",
  tag: "M3.5 12.5V4.5h8l9 9-8 8-9-9ZM8 8.5h.01",
  search: "m20 20-4.2-4.2M10.5 17a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Z",
  shield: "M12 3.5 5 6v5.5c0 4.2 2.8 7.4 7 9 4.2-1.6 7-4.8 7-9V6l-7-2.5ZM9.2 12l2 2 3.6-4",
  log: "M6 3.5h9l3 3V20.5H6V3.5ZM9 10h6M9 13.5h6M9 17h4",
  phone: "M6.5 3.5h3l1.5 4-2 1.5a11 11 0 0 0 6 6l1.5-2 4 1.5v3a2 2 0 0 1-2 2A16.5 16.5 0 0 1 4.5 5.5a2 2 0 0 1 2-2Z",
  message: "M4 5h16v11H9l-5 4V5ZM8 9.5h8M8 12.5h5",
  key: "M14.5 9.5a4 4 0 1 1-1.2-2.9M13.3 6.6 20 6.6M18 6.6v3M3.5 20.5l6-6",
  menu: "M4 7h16M4 12h16M4 17h16",
  close: "M6 6l12 12M18 6 6 18",
  plus: "M12 5v14M5 12h14",
  check: "m5 12.5 4.5 4.5L19 7.5",
  chevron: "m9 6 6 6-6 6",
  chevronDown: "m6 9 6 6 6-6",
  sun: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M5.3 18.7l1.4-1.4M17.3 6.7l1.4-1.4",
  moon: "M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5Z",
  globe: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3.5 12h17M12 3c2.6 2.6 3.8 5.6 3.8 9s-1.2 6.4-3.8 9c-2.6-2.6-3.8-5.6-3.8-9S9.4 5.6 12 3Z",
  logout: "M10 4.5H5.5v15H10M15 8l4 4-4 4M19 12H9.5",
  building: "M5 20.5v-16h9v16M14 9.5h5v11M8.5 8.5h2M8.5 12h2M8.5 15.5h2M3.5 20.5h17",
  edit: "M4 20h4L19 9l-4-4L4 16v4ZM13.5 6.5l4 4",
  trash: "M5 7h14M10 7V4.5h4V7M7 7l.8 12.5h8.4L17 7M10.5 11v5M13.5 11v5",
  calendar: "M5 6h14v14H5V6ZM5 10h14M9 3.5V7M15 3.5V7",
  clock: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7.5V12l3 2",
  flag: "M6 21V4M6 5h11l-2 4 2 4H6",
  bell: "M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15l1.5-2ZM10 20.5a2 2 0 0 0 4 0",
  copy: "M8 8h11v12H8V8ZM5 16V4h11",
  lock: "M6 11h12v9H6v-9ZM8.5 11V8a3.5 3.5 0 0 1 7 0v3",
  more: "M5 12h.01M12 12h.01M19 12h.01",
  grip: "M9 6h.01M15 6h.01M9 12h.01M15 12h.01M9 18h.01M15 18h.01",
  sliders: "M4 7h9M17 7h3M4 17h3M11 17h9M14 4.5v5M8 14.5v5",
  chevronLeft: "m15 6-6 6 6 6",
  refresh: "M20 11a8 8 0 0 0-14.5-4M4 4v4h4M4 13a8 8 0 0 0 14.5 4M20 20v-4h-4",
  alert: "M12 4 2.8 19.5h18.4L12 4ZM12 10v4.5M12 17.2h.01",
  chart: "M4 4v16h16M8 16v-5M12 16V8M16 16v-8",
  download: "M12 4v11M7.5 11 12 15.5 16.5 11M5 20h14",
  printer: "M7 8V4h10v4M7 17H4.5v-8h15v8H17M7 14h10v6H7v-6Z",
  share: "M16 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM16 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM8.7 10.5l4.6-2.6M8.7 13.5l4.6 2.6",
  play: "M7 4.5v15l12-7.5-12-7.5Z",
  table: "M4 5h16v14H4V5ZM4 10h16M4 15h16M10 5v14",
  arrowUp: "M12 19V5M6 11l6-6 6 6",
  arrowDown: "M12 5v14M6 13l6 6 6-6",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20.5c.6-4 3.6-6 7.5-6s6.9 2 7.5 6",
  male: "M10 20a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM14 10l6-6M15 4h5v5",
  female: "M12 14a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM12 14v7M8.5 18h7",
  mapPin: "M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11ZM12 12.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4Z",
  mail: "M4 6h16v12H4V6ZM4.5 6.5 12 13l7.5-6.5",
  inbox: "M3.5 13.5 6 5h12l2.5 8.5v5.5h-17v-5.5ZM3.5 13.5H9a3 3 0 0 0 6 0h5.5",
  chat: "M4 5h16v11H9l-4.5 4v-4H4V5ZM8 9.5h8M8 12.5h5",
  lifebuoy: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM5.6 5.6l3.9 3.9M14.5 14.5l3.9 3.9M18.4 5.6l-3.9 3.9M9.5 14.5l-3.9 3.9",
  golf: "M8 21c0-1.5 1.6-2.5 4-2.5s4 1 4 2.5M12 18.5V3.5l7 3.5-7 3.5",
  clipboardCheck: "M9 4.5h6V7H9V4.5ZM7 5.5H5.5v15h13v-15H17M9 14l2 2 4-4",
  note: "M5 4.5h14v11l-4.5 4.5H5V4.5ZM14.5 20v-4.5H19M8.5 9h7M8.5 12.5h4",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  database: "M12 9c4.4 0 8-1.1 8-2.5S16.4 4 12 4 4 5.1 4 6.5 7.6 9 12 9ZM4 6.5v11C4 18.9 7.6 20 12 20s8-1.1 8-2.5v-11M4 12c0 1.4 3.6 2.5 8 2.5s8-1.1 8-2.5",
  heart: "M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.4a4.3 4.3 0 0 1 7.5 2.4C19.5 15.4 12 20 12 20Z",
  card: "M3.5 6.5h17v11h-17v-11ZM3.5 10h17M7 14.5h3",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 20, ...rest }: { name: IconName; size?: number } & Omit<SVGProps<SVGSVGElement>, "name">) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
